import { ZButton } from "components/ZButton";
import { ZCheckboxButton } from "components/ZCheckboxButton";
import { ZCompactSearchBar } from "components/ZCompactSearchBar";
import { ZCounter } from "components/ZCounter";
import { ZDateTimePicker } from "components/ZDateTimePicker";
import { ZFeatureFlag } from "components/ZFeatureFlag";
import { ZIcon } from "components/ZIcon";
import { ZLabel } from "components/ZLabel";
import { ZMultiSelectDropdown } from "components/ZMultiSelectDropdown";
import { ZNumberInput } from "components/ZNumberInput";
import { ZSingleSelectDropdown } from "components/ZSingleSelectDropdown";
import { ZTextInput } from "components/ZTextInput";
import { ZTooltip } from "components/ZTooltip";
export namespace Z {
    export const Counter = ZCounter;
    export const CompactSearchBar = ZCompactSearchBar;
    export const DateTimePicker = ZDateTimePicker;
    export const Button = ZButton;
    export const SingleSelect = ZSingleSelectDropdown;
    export const MultiSelect = ZMultiSelectDropdown;
    export const TextInput = ZTextInput;
    export const NumberInput = ZNumberInput;
    export const Tooltip = ZTooltip;
    export const FeatureFlag = ZFeatureFlag;
    export const Icon = ZIcon;
    export const Label = ZLabel;
    export const CheckboxButton = ZCheckboxButton;
}
